var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user != null)?_c('div',[_c('img',{staticClass:"center",attrs:{"src":_vm.logoApp}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }